module.exports = __webpack_public_path__ + "img/page-top_btn.e530a632.svg";